// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-779433e6] {\n  fill: #fff\n}\n.st61[data-v-779433e6] {\n  fill: #60a0e0\n}\n", ""]);
// Exports
module.exports = exports;
